import { buildBehavior } from "./behavior";
export const Parental = buildBehavior({
    properties: () => ({
        children: [],
    }),
    cleanup(entity) {
        entity.children.forEach((child) => child.remove());
    },
});
export const Child = buildBehavior({
    properties: () => ({
        parent: undefined,
    }),
    cleanup(entity) {
        if (entity.parent && entity.parent.hasBehavior(Parental)) {
            entity.parent.children.splice(entity.parent.children.indexOf(entity), 1);
        }
    },
});
